
export default {

  loginForm: {
    padding: '80px 80px 100px 80px',
    maxWidth: '600px',
    margin: '40px auto 0 auto',
    background: '#fff',
    boxShadow: '0 1px 20px rgba(0, 0, 0, 0.15)'
  },

  inputIcon: { 
    color: 'rgba(0,0,0,.25)' 
  },

  logo: {
    width: '50%',
    margin: '0 auto 30px auto',
    display: 'block'
  }
}


// WEBPACK FOOTER //
// ./src/login/login.css.js